import { useMemo } from "react";
import { GetCustomerDetail } from "../services/modules/verify";
import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../index";
import { isReactSnap } from "../utils/react-snap";

export function useUser() {
  const invalidateUser = () =>
    queryClient.invalidateQueries({
      queryKey: ["user-data"],
    });

  const {
    data: userData,
    isLoading,
    refetch: refetchUser,
  } = useQuery({
    queryKey: ["user-data"],
    queryFn: async () => {
      const { resultData } = await GetCustomerDetail({
        body: {
          id_card: localStorage.getItem("idCard"),
          date_of_birth: localStorage.getItem("dob"),
        },
      });
      return resultData ? resultData[0] : null;
    },
    onError: (error) => {
      console.error(error);
    },
    enabled: !isReactSnap() && !!localStorage.getItem("idCard"),
  });

  const isLoggedIn = useMemo(() => !!userData, [userData]);

  return {
    userData,
    isLoading,
    isLoggedIn,
    invalidateUser,
    refetchUser,
  };
}
